export default __webpack_public_path__ + "static/media/sidebar_background.99cb992f.jpg";